import React, { useEffect, useState } from 'react';
import { WebsiteExperience } from '../components/website/WebsiteExperience';
import { DraftBanner } from '../components/website/DraftBanner';
import { getDraftWebsiteContent, getPublishedWebsiteContent, getRequestedStage, getWebsiteContentFromUrl, websiteDraftStorageKey, websiteDraftUpdatedEvent, websiteStorageKey, websiteUpdatedEvent, type WebsiteContent } from '../data/website';
import { useWebsiteSeo } from '../hooks/useWebsiteSeo';
import { useLiveTourDates } from '../hooks/useLiveTourDates';
export function ArtistWebsite() {
  const sharedPreviewContent = getWebsiteContentFromUrl();
  const stage = getRequestedStage();
  const isDraft = !sharedPreviewContent && stage === 'draft';
  const read = () => isDraft ? getDraftWebsiteContent() : getPublishedWebsiteContent();
  const [content, setContent] = useState<WebsiteContent>(() => sharedPreviewContent ?? read());
  const isSharedPreview = Boolean(sharedPreviewContent);
  const liveContent = useLiveTourDates(content);
  useWebsiteSeo(liveContent, isDraft ? {
    noIndex: true
  } : undefined);
  useEffect(() => {
    if (isSharedPreview) return undefined;
    // Only swap in a new object when something actually changed. Re-reading on a
    // timer would otherwise hand down a fresh reference every half-second and
    // restart every effect downstream.
    const refresh = () => setContent(current => {
      const next = read();
      return JSON.stringify(next) === JSON.stringify(current) ? current : next;
    });
    const sync = (event: Event) => setContent((event as CustomEvent<WebsiteContent>).detail ?? read());
    const watchedKey = isDraft ? websiteDraftStorageKey : websiteStorageKey;
    const watchedEvent = isDraft ? websiteDraftUpdatedEvent : websiteUpdatedEvent;
    const syncStorage = (event: StorageEvent) => {
      if (event.key === watchedKey) refresh();
    };
    const channel = 'BroadcastChannel' in window ? new BroadcastChannel(isDraft ? 'artistos-website-draft' : 'artistos-website-content') : null;
    if (channel) channel.onmessage = refresh;
    const polling = window.setInterval(refresh, 500);
    window.addEventListener(watchedEvent, sync);
    window.addEventListener('storage', syncStorage);
    window.addEventListener('focus', refresh);
    return () => {
      window.clearInterval(polling);
      channel?.close();
      window.removeEventListener(watchedEvent, sync);
      window.removeEventListener('storage', syncStorage);
      window.removeEventListener('focus', refresh);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSharedPreview, isDraft]);
  return <>
      {isDraft && <DraftBanner data-id="element-1409" data-mp="29sh5p8l6dxuu" />}
      <WebsiteExperience content={liveContent} data-id="element-1410" data-mp="29rze4p9gk7t9" />
    </>;
}